import api from "src/apis/api";

export async function fetchGeofences() {
  const { data } = await api.get("/api/v1/geofences");
  return data;
}

export async function createGeofence(payload) {
  const { data } = await api.post("/api/v1/geofences", { geofence: payload });
  return data;
}

export async function updateGeofence(id, payload) {
  const { data } = await api.patch(`/api/v1/geofences/${id}`, { geofence: payload });
  return data;
}

export async function deleteGeofence(id) {
  const { data } = await api.delete(`/api/v1/geofences/${id}`);
  return data;
}
